import type { Commitment, DsmScopeItem } from "design-scope";

function commitmentKey(c: Commitment): string {
  return `${c.designPackageId}::${c.milestoneId ?? ""}`;
}

/**
 * Append `toAdd` commitments onto a row's existing list, skipping duplicates
 * that already share the same designPackageId + milestoneId.
 */
export function appendDesignPackageCommitments(
  row: DsmScopeItem,
  toAdd: Commitment[]
): Commitment[] {
  const pending = toAdd.filter((c) => c.designPackageId);
  const seen = new Set(row.commitments.map(commitmentKey));
  const merged = [...row.commitments];
  for (const c of pending) {
    const key = commitmentKey(c);
    if (seen.has(key)) continue;
    seen.add(key);
    merged.push(c);
  }
  return merged;
}

/**
 * Upsert form commitments onto a row: replace existing entries with the same
 * designPackageId + milestoneId, otherwise append. Other packages on the row
 * are left untouched.
 */
export function upsertDesignPackageCommitments(
  row: DsmScopeItem,
  formCommitments: Commitment[]
): Commitment[] {
  const pending = formCommitments.filter((c) => c.designPackageId);
  const merged = [...row.commitments];
  for (const c of pending) {
    const key = commitmentKey(c);
    const idx = merged.findIndex((x) => commitmentKey(x) === key);
    if (idx >= 0) {
      merged[idx] = c;
    } else {
      merged.push(c);
    }
  }
  return merged;
}
